import { useAtomValue } from 'jotai';
import { checkUserAtom } from "../../store/global/atoms";

export const useCheckUser = () => {
   const checkUserBase = useAtomValue(checkUserAtom);

   return {
    checkUser: checkUserBase.mutate,
    checkUserAsync: checkUserBase.mutateAsync,
   }
}